import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b7b99f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center w-full xl:w-1200px" }
const _hoisted_2 = { class: "text-4xl md:text-5xl lg:text-6xl text-black feature-problem" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "strickout" }, null, -1))
const _hoisted_4 = { class: "text-sm md:text-lg feature-desc" }

import { ref } from 'vue'
import { onMounted, Ref } from '@vue/runtime-core'
import ProcessBar from './ProcessBar.vue'
import { useI18n } from 'vue-i18n'

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    scrollTop: null
  },
  setup(__props: any) {

const props = __props as {
  scrollTop: number
}


const { t } = useI18n()

const getElementTop = (element: any) => {
  let actualTop = element.offsetTop
  let current = element.offsetParent

  while (current !== null) {
    actualTop += current.offsetTop
    current = current.offsetParent
  }

  return actualTop
}

const stickyIndex = ref(0)
const featureRefs: Ref<Element[]> = ref([])
const featureDetailRefs: Ref<Element[]> = ref([])
const featureTitleRefs: Ref<Element[]> = ref([])
// 滚动后到达每个区块的位置，距离顶部的距离，被拆分为 200%，即 2
const distancePercents = ref([0, 0, 0, 0])
const titleHeight = ref(0)

const getFeatureWrapperRefs = (el: any) => {
  featureRefs.value.push(el)
}

const getFeatureDetailRefs = (el: any) => {
  featureDetailRefs.value.push(el)
}
const getFeatureTitleRefs = (el: any) => {
  featureTitleRefs.value.push(el)
}

const touchIndex = (index: number) => {
  if (featureRefs.value[index]) {
    featureRefs.value[index].scrollIntoView({ behavior: 'smooth' })
  }
}

const toArchitecture = () => {
  document.getElementById('architecture')?.scrollIntoView({ behavior: 'smooth' })
}

onMounted(() => {
  const setOffsetTops = () => {
    const length = featureRefs.value.length
    return featureRefs.value.map((el, index) => {
      // 64 是 header 高度
      return getElementTop(el) - ((index === length - 1) ? 0 : 64)
    })
  }
  let offsetTops = setOffsetTops()

  const itemOffsetHeight = featureDetailRefs.value[0].clientHeight
  titleHeight.value = featureTitleRefs.value[0].clientHeight

  window.addEventListener('resize', () => {
    offsetTops = setOffsetTops()
  })

  window.addEventListener('scroll', () => {
    offsetTops.forEach((offsetTop, index) => {
      if (props.scrollTop >= offsetTop) {
        stickyIndex.value = index
        const dis = (props.scrollTop - offsetTop) / itemOffsetHeight
        distancePercents.value[index] = dis >= 2 ? 2 : dis
      } else {
        distancePercents.value[index] = 0
      }
    })
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n, index) => {
        return _createElementVNode("div", {
          key: n,
          ref: getFeatureWrapperRefs,
          class: "feature-wrapper"
        }, [
          _createElementVNode("div", {
            ref: getFeatureDetailRefs,
            class: _normalizeClass(["h-screen flex flex-row items-center justify-center", `${stickyIndex.value >= index ? 'sticky top-0' : ''}`]),
            style: _normalizeStyle(`
        --distance-percent: ${distancePercents.value[index]};
        --transfer-height: -${titleHeight.value};
        `)
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createTextVNode(_toDisplayString(_unref(t)(`features.problem_${n}`)) + " ", 1),
                _hoisted_3
              ]),
              _createElementVNode("div", {
                ref: getFeatureTitleRefs,
                class: "text-4xl md:text-5xl lg:text-6xl text-black pb-5 feature-title"
              }, _toDisplayString(_unref(t)(`features.title_${n}`)), 1),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)(`features.desc_${n}`)), 1)
            ])
          ], 6)
        ])
      }), 64))
    ]),
    _createVNode(ProcessBar, {
      "distance-percents": distancePercents.value,
      onTouchIndex: touchIndex,
      onToArchitecture: toArchitecture
    }, null, 8, ["distance-percents"])
  ], 64))
}
}

})